// Language and Locale Configuration for SwipeSage

export const SUPPORTED_LANGUAGES = {
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸',
    direction: 'ltr' as const,
  },
  hi: {
    code: 'hi',
    name: 'Hindi',
    nativeName: 'हिंदी',
    flag: '🇮🇳',
    direction: 'ltr' as const,
  },
  ta: {
    code: 'ta',
    name: 'Tamil',
    nativeName: 'தமிழ்',
    flag: '🇮🇳',
    direction: 'ltr' as const,
  },
  te: {
    code: 'te',
    name: 'Telugu',
    nativeName: 'తెలుగు',
    flag: '🇮🇳',
    direction: 'ltr' as const,
  },
  bn: {
    code: 'bn',
    name: 'Bengali',
    nativeName: 'বাংলা',
    flag: '🇮🇳',
    direction: 'ltr' as const,
  },
  mr: {
    code: 'mr',
    name: 'Marathi',
    nativeName: 'मराठी',
    flag: '🇮🇳',
    direction: 'ltr' as const,
  },
} as const;

export type LanguageCode = keyof typeof SUPPORTED_LANGUAGES;

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export const LANGUAGE_CODES = Object.keys(SUPPORTED_LANGUAGES) as LanguageCode[];

// Currency configuration
export const CURRENCIES = {
  INR: {
    code: 'INR',
    symbol: '₹',
    name: 'Indian Rupee',
    position: 'before' as const,
  },
  USD: {
    code: 'USD',
    symbol: '$',
    name: 'US Dollar',
    position: 'before' as const,
  },
} as const;

export type CurrencyCode = keyof typeof CURRENCIES;

export const DEFAULT_CURRENCY: CurrencyCode = 'INR';

// Date and time formats
export const DATE_FORMATS = {
  en: {
    short: 'MM/dd/yyyy',
    long: 'MMMM dd, yyyy',
    time: 'hh:mm a',
    datetime: 'MM/dd/yyyy hh:mm a',
  },
  hi: {
    short: 'dd/MM/yyyy',
    long: 'dd MMMM, yyyy',
    time: 'hh:mm a',
    datetime: 'dd/MM/yyyy hh:mm a',
  },
  ta: {
    short: 'dd/MM/yyyy',
    long: 'dd MMMM, yyyy',
    time: 'hh:mm a',
    datetime: 'dd/MM/yyyy hh:mm a',
  },
  te: {
    short: 'dd/MM/yyyy',
    long: 'dd MMMM, yyyy',
    time: 'hh:mm a',
    datetime: 'dd/MM/yyyy hh:mm a',
  },
  bn: {
    short: 'dd/MM/yyyy',
    long: 'dd MMMM, yyyy',
    time: 'hh:mm a',
    datetime: 'dd/MM/yyyy hh:mm a',
  },
  mr: {
    short: 'dd/MM/yyyy',
    long: 'dd MMMM, yyyy',
    time: 'hh:mm a',
    datetime: 'dd/MM/yyyy hh:mm a',
  },
} as const;

// Number formats
export const NUMBER_FORMATS = {
  en: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },
  hi: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },
  ta: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },
  te: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },
  bn: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },
  mr: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },
} as const; 